import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { Page } from "../pages/page";
import "@fontsource-variable/inter";
import "../css/app.css";
import "popdock-themes/css/popdock.css";
import "../site.css";
import { HelpProvider } from "eone-ui/help-context";
import { productSlug } from "./product";

const bugsnagApiKey = import.meta.env.VITE_BUGSNAG_API_KEY ?? "";
if (bugsnagApiKey) {
    Bugsnag.start({
        apiKey: bugsnagApiKey,
        plugins: [new BugsnagPluginReact()],
    });
}

const BugsnagErrorBoundary = bugsnagApiKey
    ? Bugsnag.getPlugin("react").createErrorBoundary(React)
    : React.Fragment;
const logoUrl = import.meta.env.VITE_LOGO_URL ?? "";
const logoLabel = import.meta.env.VITE_LOGO_LABEL ?? "";
const logoText = import.meta.env.VITE_LOGO_TEXT ?? "";
const productLogoUrl = import.meta.env.VITE_PRODUCT_LOGO_URL ?? "/popdock-color.svg";
const productLogoLabel = import.meta.env.VITE_PRODUCT_LOGO_LABEL ?? "Popdock";
const productLogoText = import.meta.env.VITE_PRODUCT_LOGO_TEXT ?? "";

document.documentElement.dataset.product = productSlug;

export function mountPage(PageComponent) {
    function App() {
        useEffect(() => {
            if (productSlug !== "popdock") return;

            const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            if (prefersDark) import("popdock-themes/css/popdock-dark.css").catch(() => { });
        }, []);

        return (
            <BugsnagErrorBoundary>
                <HelpProvider>
                    <Page
                        LogoUrl={logoUrl}
                        LogoLabel={logoLabel}
                        LogoText={logoText}
                        ProductLogoUrl={productLogoUrl}
                        ProductLogoLabel={productLogoLabel}
                        ProductLogoText={productLogoText}>
                        <PageComponent />
                    </Page>
                </HelpProvider>
            </BugsnagErrorBoundary>
        );
    }

    createRoot(document.getElementById("content")).render(
        <React.StrictMode><App /></React.StrictMode>
    );
}
